// ----------------------------------------------------------------------------------
// Counter
// ----------------------------------------------------------------------------------

function counterInit(element,duration) {

    var maxValue=element.text();
    if (maxValue) {
        maxValue=maxValue.replace(".","");
        maxValue=parseInt(maxValue);
    }

    element.attr('data-max-value',maxValue);
    element.attr('data-value',0);
    element.text(0);

    var ms=15;

    var steps=duration/ms;



    var count=parseFloat(maxValue/steps);
    element.attr('data-count',count);



    counterCount(element,duration);
}


function counterCount(element,duration) {

    var ms=15;

    var maxValue = element.attr('data-max-value');
    if (maxValue) {
        maxValue=parseInt(maxValue);
    }

    var count=parseFloat(element.attr('data-count'));


    var value=element.attr('data-value');
    value=parseFloat(value);

    var newValue=parseFloat(value+count);


    if (newValue>maxValue) {
        newValue = maxValue;
    }

    element.attr('data-value',newValue);



    element.text(Math.round(newValue).toLocaleString('de-DE'));

    //if (newValue < maxValue) {
    console.log('TimeOut wird gestartet');
    setTimeout(function() {counterCount(element,duration)},ms)
    //}


}


$(document).ready(function() {




});